const labels = {
    unfulfilled: 'Order placed',
    confirmed: 'Order confirmed',
    partially_shipped: 'Some items dispatched',
    shipped: 'Dispatched',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
    pending_payment: 'Awaiting payment',
    payment_review: 'Payment under review',
    paid_exception: 'Order under review',
};

export function orderStatusLabel(value) {
    const status = String(value || 'pending');
    return labels[status.toLowerCase()] || status.replace(/_/g, ' ');
}

export function orderStatusTone(value) {
    const status = String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (['delivered', 'completed', 'paid', 'captured'].includes(status)) return 'positive';
    if (['unfulfilled', 'placed', 'order_placed', 'confirmed', 'order_confirmed', 'authorized'].includes(status)) return 'info';
    if (['partially_shipped', 'shipped', 'dispatched', 'in_transit', 'out_for_delivery'].includes(status)) return 'transit';
    if (['pending', 'pending_payment', 'payment_review', 'paid_exception', 'processing', 'packed', 'refund_pending', 'unpaid'].includes(status)) return 'warning';
    if (['cancelled', 'canceled', 'failed', 'expired'].includes(status)) return 'negative';
    if (['returned', 'return_requested', 'return_received', 'refunded', 'partially_refunded'].includes(status)) return 'return';
    return 'neutral';
}
